import Vue from 'vue';
import LinearScale from 'linear-scale';
import { point, distance } from '@turf/turf';
import Slick from 'vue-slick';
import Photographer from '../../components/Photographer';
import AnimatedComponent from '../../components/Animated';

let els;

if ((els = document.querySelectorAll('.postcode-map')).length > 0) {
    for (let i = 0; i < els.length; i++) {
        const el = els[i];

        new Vue({
            el: el,
            name: 'PostcodeMap',
            components: { Slick, Photographer, AnimatedComponent },
            data() {
                return {
                    opened: false,
                    cities: [],
                    citiesSelect: [],
                    postCode: '',
                    searchFocused: false,
                    currentCity: false,
                    openModal: false,
                    displayModal: "none",
                    currentStudio: false,
                    showSlick: true,
                    convert_coords: window.ConvertCoords,
                    slickOptions: {
                        arrows: false,
                        dots: false,
                        infinite: true,
                        slidesToShow: 1
                    },
                    markersSizes: {
                        1: 'w-6 lg:w-9 hover:w-8 lg:hover:w-11',
                        2: 'w-8 lg:w-12 hover:w-10 lg:hover:w-14',
                        3: 'w-12 lg:w-16 hover:w-14 lg:hover:w-18'
                    },
                    markersActiveSizes: {
                        1: 'w-6 lg:w-9 hover:w-8 lg:hover:w-11',
                        2: 'w-8 lg:w-12 hover:w-10 lg:hover:w-14',
                        3: 'w-12 lg:w-16 hover:w-14 lg:hover:w-18'
                    }
                };
            },
            methods: {
                getImage: window.getImage,
                saveData(mycity, mystudio) {
                    localStorage.setItem('booking-selected-city', mycity.toLowerCase());
                    localStorage.setItem('booking-selected-studio', mystudio);
                    document.location.href = document.location.origin + "/reserver-ma-seance";
                },
                slickNext() {
                    this.$refs.slick.next();
                },
                slickPrev() {
                    this.$refs.slick.prev();
                },
                selectCity(city) {
                    if (this.isCurrentCity(city)) return;

                    this.showSlick = false;

                    this.currentCity = city;

                    this.$nextTick(function () {
                        this.$nextTick(function () {
                            this.showSlick = true;
                        });
                    });
                },
                isCurrentCity(city) {
                    return this.currentCity && city.id === this.currentCity.id;
                },
                getMarkerSize(size, active) {
                    if (typeof active !== 'undefined')
                        return this.markersActiveSizes[size];
                    else
                        return this.markersSizes[size]
                },
                searchCity() {
                    axios.post('/api/postcode', null, {
                        params: {
                            postcode: this.postCode
                        }
                    }).then((response) => {
                        this.findNearest(response.data);
                    })
                },
                getMarkerStyle(coords) {
                    const position = this.coordsToPost(coords);

                    return {
                        top: position.y + '%',
                        left: position.x + '%'
                    }
                },
                findNearest(coords) {
                    let nearestCity;
                    let newDistance;
                    let nearestDistance = Infinity;

                    this.cities.forEach((city) => {
                        if (city.studios.length > 0 && (newDistance = (this.getDistance(city.coords, coords))) < nearestDistance) {
                            nearestDistance = newDistance;
                            nearestCity = city;
                        }
                    });

                    this.selectCity(nearestCity);
                },
                getDistance(coords1, coords2) {
                    const from = point([coords1.lat, coords1.lng]);
                    const to = point([coords2.lat, coords2.lng]);

                    return distance(from, to, { units: "meters" });
                },
                getClickPos(event) {
                    const pos = {
                        x: event.offsetX / 568 * 100,
                        y: event.offsetY / 576 * 100,
                    };

                },
                posToCoords(coords) {
                    const ScalerLatY = LinearScale(
                        [
                            this.convert_coords.pos0.y,
                            this.convert_coords.pos1.y
                        ],
                        [
                            this.latToY(this.convert_coords.pos0.lat),
                            this.latToY(this.convert_coords.pos1.lat)
                        ]
                    );
                    const ScalerLngX = LinearScale(
                        [
                            this.convert_coords.pos0.x,
                            this.convert_coords.pos1.x
                        ],
                        [
                            this.convert_coords.pos0.lng,
                            this.convert_coords.pos1.lng
                        ]
                    );

                    return {
                        lat: this.yToLat(ScalerLatY(coords.y)),
                        lng: ScalerLngX(coords.x)
                    };
                },
                coordsToPost(LatLng) {
                    const ScalerLngY = LinearScale(
                        [
                            this.latToY(this.convert_coords.pos0.lat),
                            this.latToY(this.convert_coords.pos1.lat)
                        ],
                        [
                            this.convert_coords.pos0.y,
                            this.convert_coords.pos1.y
                        ]
                    );
                    const ScalerLatX = LinearScale(
                        [
                            this.convert_coords.pos0.lng,
                            this.convert_coords.pos1.lng
                        ],
                        [
                            this.convert_coords.pos0.x,
                            this.convert_coords.pos1.x
                        ]
                    );

                    return {
                        y: ScalerLngY(this.latToY(LatLng.lat)),
                        x: ScalerLatX(LatLng.lng)
                    };
                },
                latToY(lat) {
                    return this.rad2deg(Math.asinh(Math.tan(this.deg2rad(lat))));
                },
                yToLat(y) {
                    return this.rad2deg(Math.atan(Math.sinh(this.deg2rad(y))));
                },
                deg2rad(degrees) {
                    var pi = Math.PI;
                    return degrees * (pi / (180 * 1.5));
                },
                rad2deg(radians) {
                    var pi = Math.PI;
                    return radians * ((180 * 1.5) / pi);
                },
                reviews(studio) {
                    this.currentStudio = studio;
                    this.openModal = true;
                    this.displayModal = "block";
                },
                closeModal() {
                    this.openModal = false;
                    this.displayModal = "none";
                }
            },
            created() {
                this.cities = window.passdata.cities;
                this.citiesSelect = window.passdata.citiesSelect;
            },
            beforeMount() {
                this.currentCity = this.cities[0];
            }
        });
    }
}
